import { defineMessages } from 'react-intl'

export default defineMessages({
  // Global
  inventoryHeader: {
    id: 'app.inventory.header',
    defaultMessage: 'Home Inventory',
  },
  inventoryValue: {
    id: 'app.inventory.value',
    defaultMessage: 'Value',
  },
  inventoryAddNew: {
    id: 'app.inventory.addNew',
    defaultMessage: 'Add new',
  },

  // Group/s
  inventoryRoom: {
    id: 'app.inventory.room',
    defaultMessage: 'Room',
  },
  inventoryAddNewRoom: {
    id: 'app.inventory.addNewRoom',
    defaultMessage: 'Add new room',
  },
  inventoryRooms: {
    id: 'app.inventory.rooms',
    defaultMessage: 'Rooms',
  },
  inventoryPlaceholderRoom: {
    id: 'app.inventory.placeholder.room',
    defaultMessage: 'Room name',
  },
  inventoryValidationRoom: {
    id: 'app.inventory.validation.room',
    defaultMessage: 'Room name is required!',
  },
  inventoryValidationRoomLength: {
    id: 'app.inventory.validation.roomLength',
    defaultMessage: 'Room name too long!',
  },
  inventoryGroupSaveSuccess: {
    id: 'app.inventory.group.save.success',
    defaultMessage: 'Room saved successfully',
  },
  // Rename Group
  inventoryPlaceholderRoomNewName: {
    id: 'app.inventory.placeholder.newName',
    defaultMessage: 'New name',
  },
  inventoryEnterNewNameBelow: {
    id: 'app.inventory.group.enterNewName',
    defaultMessage: 'Enter new name below',
  },
  // Delete Group
  inventoryGroupDeleteSuccess: {
    id: 'app.inventory.group.delete.success',
    defaultMessage: 'Room deleted successfully',
  },
  inventoryGroupDeleteConfirmMessage: {
    id: 'app.inventory.group.delete.confirmMessage',
    defaultMessage:
      'Are you sure you want to delete this room? By doing so you will also delete all items included in this room.',
  },

  // Item/s
  inventoryItem: {
    id: 'app.inventory.item',
    defaultMessage: 'Item',
  },
  inventoryItems: {
    id: 'app.inventory.items',
    defaultMessage: 'Items',
  },
  inventoryAddNewItem: {
    id: 'app.inventory.addNewItem',
    defaultMessage: 'Add new item',
  },
  inventoryNoItems: {
    id: 'app.inventory.noItems',
    defaultMessage: 'No items available',
  },

  // Add Item
  inventoryPlaceholderItemName: {
    id: 'app.inventory.placeholder.item.name',
    defaultMessage: 'Item name',
  },
  inventoryValidationItemName: {
    id: 'app.inventory.validation.item.name',
    defaultMessage: 'Item name is required!',
  },
  inventoryValidationItemNameLength: {
    id: 'app.inventory.validation.item.nameLength',
    defaultMessage: 'Item name too long!',
  },
  inventoryLabelQuantity: {
    id: 'app.inventory.label.quantity',
    defaultMessage: 'Quantity',
  },
  inventoryValidationItemQuantity: {
    id: 'app.inventory.validation.item.quantity',
    defaultMessage: 'Quantity is required!',
  },
  inventoryValidationItemQuantityInvalid: {
    id: 'app.inventory.validation.item.quantityInvalid',
    defaultMessage: 'Quantity is invalid!',
  },
  inventoryLabelPrice: {
    id: 'app.inventory.label.price',
    defaultMessage: 'Price',
  },
  inventoryValidationItemPrice: {
    id: 'app.inventory.validation.item.price',
    defaultMessage: 'Price is required!',
  },
  inventoryValidationItemPriceInvalid: {
    id: 'app.inventory.validation.item.priceInvalid',
    defaultMessage: 'Price is invalid!',
  },
  inventoryLabelNotes: {
    id: 'app.inventory.label.notes',
    defaultMessage: 'Notes',
  },
  inventoryPlaceholderNotes: {
    id: 'app.inventory.placeholder.notes',
    defaultMessage: 'Product description...',
  },
  inventoryItemSaveSuccess: {
    id: 'app.inventory.item.save.success',
    defaultMessage: 'Item saved successfully',
  },
  inventoryTotalValue: {
    id: 'app.inventory.totalValue',
    defaultMessage: 'Total',
  },

  // Delete Item
  inventoryItemDeleteSuccess: {
    id: 'app.inventory.item.delete.success',
    defaultMessage: 'Item deleted successfully',
  },
  inventoryItemDeleteConfirmMessage: {
    id: 'app.inventory.item.delete.confirmMessage',
    defaultMessage:
      'Are you sure you want to delete this item? The object will be removed permanently.',
  },

  // Delete File
  inventoryFileDeleteConfirmMessage: {
    id: 'app.inventory.file.delete.confirmMessage',
    defaultMessage:
      'Do you really want to remove this photo from inventory? This process cannot be undone.',
  },
})
